import { render, staticRenderFns } from "./InstallStep3.vue?vue&type=template&id=08be22d6&"
import script from "./InstallStep3.vue?vue&type=script&lang=js&"
export * from "./InstallStep3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports